module.exports = __webpack_public_path__ + "static/img/1.2d759ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/upload/commonality/20251009/1.jpg
// module id = pjSR
// module chunks = 7